import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { AppConfig } from '@appconfig';
import { HttpClient } from '@angular/common/http';
import { HttpRepo } from '@shared/services/httprepo';
import { AuthService } from '@services/auth.service';
import { ApiEndPointType } from '@shared/enums/common';

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  constructor(private http: HttpClient,private appConfig:AppConfig,
    private httpRepo:HttpRepo,private auth:AuthService) { 
      this.httpRepo.setAbsoluteUrl(this.auth.getCompanyId(),ApiEndPointType.FS);
    }
  addNote(data:any){
    return of({
      ID:10,
      Content:data.Content,
      IsPinned:false,
      CreateDate:new Date(),
      User:{ID:"5",FirstName:"d_LSE_1",LastName:"_ln",Phone:"999-999-9999",Email:"a@a.com",SecurityRoles:[{}]}
    });
  }
  saveBillingEditData(CustomerID:string,data:any){
    // return this.http.put<any>(this.appConfig.getApiUrl()+"/companies/"+CompanyID+"/customers/"+CustomerID,data);
    return this.httpRepo.Put("customers/"+CustomerID,data);
  }
}
